import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const occupationalDisabilityOverHeadTwoView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
}: Props) => {
    const occupationalDisabilityOverheadTwo =
        formDetails?.claimInformation?.occupationalDisabilityOverheadTwo;

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={12} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Occupational Disability and Overhead Expenses Benefit Claims continued
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                {occupationalDisabilityOverheadTwo?.map((occupation: any, index: number) => (
                    <Grid key={index}>
                        <ExpansionPanel name={`Occupation ${index + 1}`}>
                            <Grid container justify="flex-start">
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Employer Name"
                                        value={occupation.companyName}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Nature of Occupation"
                                        value={occupation.natureOfOccupation}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Start date"
                                        value={getDisplayDate(occupation.startDate)}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="End date"
                                        value={getDisplayDate(occupation.endDate)}
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanel>
                    </Grid>
                ))}
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const OccupationalDisabilityOverHeadTwoView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(occupationalDisabilityOverHeadTwoView));
